import { create } from "zustand"

interface NavigationGuardState {
  shouldBlock: boolean
  onNavigationConfirmHandler: (() => void) | null
  setShouldBlock: (shouldBlock: boolean) => void
  setOnNavigationConfirmHandler: (cb: (() => void) | null) => void
}

export const useNavigationGuardStore = create<NavigationGuardState>((set) => ({
  shouldBlock: false,
  onNavigationConfirmHandler: null,
  setShouldBlock: (shouldBlock) => set({ shouldBlock }),
  setOnNavigationConfirmHandler: (onNavigationConfirmHandler) => set({ onNavigationConfirmHandler }),
}))
